import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'

export const useKeepAlive = (params?: {
  onLeave?: () => void
  onStart?: () => void
  
  onActivated?: () => void
  onMounted?: () => void
  onBeforeUnmount?: () => void,

  isStopOnBlur?: boolean
}) => {
  const isComponentActive = ref(false)
  const isWindowFocused = ref(false)
  
  const isMounted = ref(false)
  const isPaused = ref(false)

  const componentLastActive: Ref<Date | null> = ref(null)
  
  const componentShouldRefresh = () => {
    return !componentLastActive.value || (componentLastActive.value && (new Date().getTime() - componentLastActive.value.getTime()) > (1000 * 60 * 5))
  }

  const onStart = () => {
    if (isComponentActive.value) return
    isWindowFocused.value = true
    
    if (params?.onStart) params?.onStart()

    isComponentActive.value = true
    componentLastActive.value = new Date()
  }

  const onLeave = () => {
    if (!isComponentActive.value) return
    isWindowFocused.value = false

    if (params?.onLeave) params?.onLeave()

    isComponentActive.value = false
  }
  
  onMounted(() => {
    if (isMounted.value) return
    isWindowFocused.value = true

    if (params?.onMounted) params?.onMounted()
    onStart()

    isMounted.value = true
  })

  if (Capacitor.isNativePlatform()) {
    App.addListener('resume', () => {
      if (!isMounted.value || !isPaused.value) return
      isWindowFocused.value = true

      onStart()
      if (params?.onActivated) params.onActivated()

      isPaused.value = false
    })

    App.addListener('pause', () => {
      if (!isMounted.value || !isComponentActive.value) return
      isWindowFocused.value = false
      
      onLeave()

      isPaused.value = true
      isComponentActive.value = false
    })
  } else {
    // window.addEventListener('focus', () => {
    //   isWindowFocused.value = true

    //   if (!isMounted.value || !isPaused.value || params?.isStopOnBlur === false) return

    //   onStart()
    //   if (params?.onActivated) params.onActivated()

    //   isPaused.value = false
    // })

    // window.addEventListener('blur', () => {
    //   isWindowFocused.value = false

    //   if (!isMounted.value || !isComponentActive.value || params?.isStopOnBlur === false) return
      
    //   onLeave()

    //   isPaused.value = true
    // })
  }

  onActivated(() => {
    if (!isMounted.value) return

    isWindowFocused.value = true

    if (params?.onActivated) params.onActivated()
    onStart()
  })

  onDeactivated(() => {
    if (!isMounted.value) return
    
    isWindowFocused.value = false
    onLeave()

    isComponentActive.value = false
  })

  onBeforeUnmount(() => {
    if (!isMounted.value) return

    isWindowFocused.value = false
    if (params?.onBeforeUnmount) params?.onBeforeUnmount()
    onLeave()

    isMounted.value = false
    isComponentActive.value = false
  })

  return {
    isComponentActive,
    componentLastActive,
    isWindowFocused,
    componentShouldRefresh
  }
}